module.exports = __webpack_public_path__ + "static/img/playing.4089be6.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/playing.gif
// module id = NpbT
// module chunks = 2